// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Loader_spinner__1oBcK"};